(() => {
  const SECTION_SELECTOR = '.mt-kj-service-features[data-section-id]';

  const initSection = (section) => {
    if (!section || section.dataset.mtKjServiceFeaturesInitialized === 'true') {
      return;
    }

    section.dataset.mtKjServiceFeaturesInitialized = 'true';
  };

  const initAllSections = (container = document) => {
    container.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSections());
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllSections(event.target);
  });
})();
